"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.me = void 0;
var request = require("superagent");
var HttpDriver = (function () {
    function HttpDriver() {
        var _this = this;
        this.Post = function (url, token, dataToSent, bDisplayError) {
            if (bDisplayError === void 0) { bDisplayError = true; }
            return new Promise(function (c, r) {
                request
                    .post(url)
                    .set("x-access-token", token)
                    .set("Content-Type", "application/json")
                    .type("json")
                    .send(dataToSent)
                    .then(function (res) {
                    var response = res.body;
                    if (response === undefined) {
                        response = {
                            message: "Protocol error, empty err: " + url,
                            srvTime: -1,
                            status: 0,
                        };
                        _this.warnError(url, response, bDisplayError);
                    }
                    if (response.status !== 0 && response.status !== 1) {
                        response = {
                            message: "Protocol error, bad response: " + JSON.stringify(response),
                            srvTime: -1,
                            status: 0,
                        };
                        _this.warnError(url, response, bDisplayError);
                    }
                    if (response.status === 1 && (res.status < 200 || res.status > 299)) {
                        response = {
                            message: "Error status: " + res.status,
                            srvTime: -1,
                            status: 0,
                        };
                        _this.warnError(url, response, bDisplayError);
                    }
                    return c(response);
                }).catch(function (err) {
                    var responseErr = {
                        message: err,
                        srvTime: -1,
                        status: 0,
                    };
                    _this.warnError(url, responseErr, bDisplayError);
                    return c(responseErr);
                });
            });
        };
        this.GetFile = function (url, token) {
            return new Promise(function (c, r) {
                request
                    .get(url)
                    .set("x-access-token", token)
                    .set("Content-Type", "application/json;charset=UTF-8")
                    .then(function (res) {
                    if (res.status < 200 || res.status > 299) {
                        return r("Server returned status " + res.status);
                    }
                    if (res.body === null || res.body === undefined) {
                        res.body = { fileName: "Error Server did not return any data..." };
                    }
                    if (typeof (res.body.fileName) === "string" && res.body.fileName.startsWith("Error")) {
                        return r(res.body.fileName);
                    }
                    else {
                        return c(res.body);
                    }
                }).catch(function (err) {
                    console.error("** in catch!!!\n" + err.stack);
                });
            });
        };
    }
    HttpDriver.prototype.HttpDriver = function () {
    };
    HttpDriver.prototype.ValidateServerName = function (srvName, defaultName) {
        if (srvName === undefined || srvName.trim().length === 0) {
            srvName = defaultName;
        }
        return srvName.trim();
    };
    HttpDriver.prototype.setCertificate = function (certifName) {
        if (certifName === void 0) { certifName = "main"; }
        return;
    };
    HttpDriver.prototype.PostFile = function (url, token, dbName, fileName, buf) {
        return new Promise(function (c, r) {
            request
                .post(url)
                .set("x-access-token", token)
                .field("content", buf)
                .field("fileName", fileName)
                .field("dbName", dbName)
                .then(function (res) {
                if (res.status < 200 || res.status > 299) {
                    return r("Error status " + res.status);
                }
                if (res.body === null || res.body === undefined) {
                    res.body = { fileName: "Error: Server did not return any data..." };
                }
                if (res.body.fileName.startsWith("Error")) {
                    return r(res.body.fileName);
                }
                return c(res.body);
            })
                .catch(function (err) {
                console.error("** in catch!!!\n" + err.stack);
                return r(err);
            });
        });
    };
    HttpDriver.prototype.warnError = function (url, responseErr, bDisplayError) {
        if (bDisplayError) {
            if (responseErr.stack !== undefined) {
                console.error("Error in url: " + url + " => " + responseErr.stack);
            }
            else {
                console.error("Error in url: " + url + " => " + responseErr.message);
            }
        }
    };
    return HttpDriver;
}());
exports.me = new HttpDriver();
